/**
 * Loại biên lai
 */
export default {
  // Biên lai thu tiền
  PaymentReceipt: 0,
  // Biên lai thu tạm ứng án phí, lệ phí tòa án'
  AdvanceReceipt: 1,
  // Biên lai thu tiền nộp NSNN
  PaymentReceiptNSNN: 2,
  // Biên lai thu tiền THA theo đơn yêu cầu
  RequestReceipt: 3,
  // Biên lai thu phí, lệ phí
  FeeReceipt: 4
};
